import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'; // ★ここ
import {
  Box,
  Container,
  Paper,
  Typography,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

interface GroupData {
  id: string;
  name: string;
}

interface MarkdownData {
  id: string;
  title: string;
  content: string;
  groupId: string;
}

const MarkdownSelectList: React.FC = () => {
  const [markdownList, setMarkdownList] = useState<MarkdownData[]>([]);
  const [groupList, setGroupList] = useState<GroupData[]>([]);
  const navigate = useNavigate();
  const { groupId } = useParams<{ groupId: string }>(); // ★ここ

  useEffect(() => {
    loadAll();
  }, [groupId]); // ★groupIdが変わったら再ロード

  const loadAll = () => {
    const savedMarkdown = localStorage.getItem('markdown-list');
    const savedGroup = localStorage.getItem('group-list');
    if (savedMarkdown) {
      const allList: MarkdownData[] = JSON.parse(savedMarkdown);
      if (groupId) {
        setMarkdownList(allList.filter(doc => doc.groupId === groupId)); // ★フィルタ
      } else {
        setMarkdownList(allList);
      }
    }
    if (savedGroup) {
      setGroupList(JSON.parse(savedGroup));
    }
  };

  const getGroupName = (groupId: string) => {
    const group = groupList.find((g) => g.id === groupId);
    return group ? group.name : '不明';
  };

  const columns: GridColDef[] = [
    { field: 'title', headerName: 'タイトル', flex: 1 },
    { field: 'groupName', headerName: 'グループ', flex: 1 },
  ];

  const rows = markdownList.map((doc) => ({
    id: doc.id,
    title: doc.title,
    groupName: getGroupName(doc.groupId),
  }));

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          マークダウンを選択
        </Typography>

        {markdownList.length > 0 ? (
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            pageSizeOptions={[5, 10]}
            onRowClick={(params) => navigate(`/detail/${params.id}`)}
            disableRowSelectionOnClick
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            登録されたMarkdownがありません。
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default MarkdownSelectList;
